/**
 * Journey panel status icons — small SVG indicators for section progress.
 */

/** Filled circle with checkmark — indicates a completed section. */
export function DoneCircle() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="11" className="fill-accent" />
      <path
        d="M6 11.5l3.5 3 6.5-7"
        stroke="#fff"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Hollow circle — indicates a pending section. */
export function PendingCircle() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="10" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
    </svg>
  );
}

/** Partially filled circle with animated dash — indicates an in-progress section. */
export function InProgressCircle() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      aria-hidden="true"
      className="motion-reduce:[&_animateTransform]:![animation-play-state:paused]"
    >
      <circle cx="11" cy="11" r="10" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" />
      <circle
        cx="11"
        cy="11"
        r="10"
        className="stroke-accent motion-reduce:animate-none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="20 43"
        strokeDashoffset="-5"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 11 11"
          to="360 11 11"
          dur="3s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
